/* app/ui/content/load */

define(
	'app/ui/content/load',[
		'jquery',
		'util/mediaqueries'
	],

	function ( $, MediaQueries ) {

		return {
			init: function(){
				MediaQueries.register([{
					queries: 'screen and (min-width: 700px)',
					shouldDegrade: false,
					match: function(){
						require([
							'app/ui/content/content'
						], function( Content ){
							Content.init();
						});
					}
				}]);
			}
		};
	}
);


